.faqsContent {
  div {
    margin-bottom: 1.5rem;
    line-height: 1.6;
    color: #333;

    &:last-child {
      margin-bottom: 0;
    }
  }
  .boldInfoMessage {
    font-weight: bold;
    color: var(--yellow);
  }
}
